export const css = {
    root: '_19W6CrNl',
    triggerWrapper: '_3SHFZSJh',
    arrow: 'XlYuXx3U',
    inputTrailing: '_3wx7pDFy',
    ' _key': 'certwise-theme/dojo/typeahead'
};
export default css;
